import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import HeroLicenciatura from "../components/TopPage";

export default function LicenciaturaMarketingPage() {
  return (
    <div className="app-root">
      <Navbar />

      <main className="w-full">
        <HeroLicenciatura />
        {/* ===== NUESTRA IDENTIDAD ===== */}
        <section
          className="w-full"
          style={{
            position: "relative",
            background: "#fff",
            padding: "3rem 1rem",
            overflow: "hidden",
          }}
        >
          {/* Imagen de fondo con baja opacidad */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: "url('/images/UNICACH.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center 40%",
              backgroundSize: "35%", // tamaño
              opacity: 0.2, //visibilidad
              filter: "blur(0.5px)", //difuminado
              pointerEvents: "none",
              zIndex: 0,
            }}
          />

          {/* Contenido */}
          <div
            style={{
              position: "relative",
              zIndex: 1,
              maxWidth: 1200,
              margin: "0 auto",
            }}
          >
            {/* Encabezado */}
            <div style={{ marginBottom: 18, textAlign: "left" }}>
              <div
                style={{
                  color: "#F2933F",
                  fontWeight: 800,
                  letterSpacing: ".5px",
                  marginBottom: 6,
                }}
              >
                NUESTRA
              </div>
              <h2 style={{ color: "#0f3b63", fontWeight: 900, margin: 0 }}>
                IDENTIDAD
              </h2>
            </div>

            {/* Grid de tarjetas */}
            <div className="grid" style={{ alignItems: "stretch" }}>
              {/* ---- Misión ---- */}
              <div className="col-12 md:col-4" style={{ padding: 6 }}>
                <div
                  style={{
                    height: "100%",
                    border: "2px solid #F3B067",
                    borderRadius: 10,
                    padding: "0.9rem",
                    background: "rgba(255,255,255,0.9)",
                    backdropFilter: "blur(2px)",
                    boxShadow: "0 4px 12px rgba(15,59,99,.05)",
                    fontSize: "0.95rem",
                  }}
                >
                  <h3
                    style={{
                      color: "#0f3b63",
                      fontWeight: 900,
                      marginTop: 0,
                      marginBottom: 8,
                      fontSize: "1.2rem",
                    }}
                  >
                    Misión
                  </h3>
                  <p style={{ color: "#3d4e61", lineHeight: 1.6, margin: 0 }}>
                    Formar mentes creativas y estratégicas, capaces de liderar
                    la transformación digital en las organizaciones. Nuestro
                    propósito es formar profesionales que diseñen, desarrollen e
                    implementen estrategias innovadoras en medios digitales que
                    impulsen la competitividad y productividad de las empresas.
                  </p>
                  <p style={{ color: "#3d4e61", lineHeight: 1.6 }}>
                    Todo esto se logra con una visión integral de los contextos
                    económicos, culturales, políticos y sociales, promoviendo
                    siempre los valores de equidad, justicia y responsabilidad
                    social y ambiental.
                  </p>
                </div>
              </div>

              {/* ---- Visión ---- */}
              <div className="col-12 md:col-4" style={{ padding: 6 }}>
                <div
                  style={{
                    height: "100%",
                    border: "2px solid #F3B067",
                    borderRadius: 10,
                    padding: "0.9rem",
                    background: "rgba(255,255,255,0.9)",
                    backdropFilter: "blur(2px)",
                    boxShadow: "0 4px 12px rgba(15,59,99,.05)",
                    fontSize: "0.95rem",
                  }}
                >
                  <h3
                    style={{
                      color: "#0f3b63",
                      fontWeight: 900,
                      marginTop: 0,
                      marginBottom: 8,
                      fontSize: "1.2rem",
                    }}
                  >
                    Visión
                  </h3>
                  <p style={{ color: "#3d4e61", lineHeight: 1.6, margin: 0 }}>
                    La Licenciatura de Marketing Digital está consolidada como
                    un programa educativo de excelencia, reconocido por la
                    calidad de su enseñanza y por la formación integral de sus
                    egresados. Se proyecta como referente nacional e
                    internacional en la generación de conocimiento y
                    transferencia de tecnología en marketing digital y en el
                    entorno empresarial.
                  </p>
                  <p style={{ color: "#3d4e61", lineHeight: 1.6 }}>
                    Sus profesionistas contribuyen al desarrollo de México con
                    creatividad, innovación, ética y un fuerte compromiso con la
                    transformación social.
                  </p>
                </div>
              </div>

              {/* ---- Valores ---- */}
              <div className="col-12 md:col-4" style={{ padding: 6 }}>
                <div
                  style={{
                    height: "100%",
                    border: "2px solid #F3B067",
                    borderRadius: 10,
                    padding: "0.9rem",
                    background: "rgba(255,255,255,0.9)",
                    backdropFilter: "blur(2px)",
                    boxShadow: "0 4px 12px rgba(15,59,99,.05)",
                    fontSize: "0.95rem",
                  }}
                >
                  <h3
                    style={{
                      color: "#0f3b63",
                      fontWeight: 900,
                      marginTop: 0,
                      marginBottom: 8,
                      fontSize: "1.2rem",
                    }}
                  >
                    Valores
                  </h3>
                  <p style={{ color: "#3d4e61", lineHeight: 1.6 }}>
                    La Licenciatura en Marketing Digital promueve los siguientes
                    valores:
                  </p>
                  <ul
                    style={{
                      margin: 0,
                      paddingLeft: 18,
                      color: "#3d4e61",
                      lineHeight: 1.7,
                      fontSize: "0.95rem",
                    }}
                  >
                    <li>
                      <b>Innovación:</b> Fomenta la generación de ideas y
                      metodologías que transformen el entorno.
                    </li>
                    <li>
                      <b>Equidad y justicia:</b> Impulsa un trato digno, justo e
                      incluyente.
                    </li>
                    <li>
                      <b>Responsabilidad social y ambiental:</b> Compromiso con
                      la sociedad y el medio ambiente.
                    </li>
                    <li>
                      <b>Ética profesional:</b> Actuación responsable y
                      comprometida.
                    </li>
                    <li>
                      <b>Creatividad estratégica:</b> Estimula soluciones
                      originales orientadas a resultados.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ===== MODALIDAD VIRTUAL ===== */}
        <section
          className="w-full"
          style={{
            background: "#f6f8fb",
          }}
        >
          <div
            className="grid align-items-center"
            style={{ maxWidth: 1200, margin: "0 auto" }}
          >
            {/* Texto */}
            <div className="col-12 md:col-7" style={{ paddingRight: "1rem" }}>
              <div
                style={{
                  color: "#F2933F",
                  fontWeight: 800,
                  letterSpacing: ".4px",
                  marginBottom: 6,
                  textTransform: "uppercase",
                }}
              >
                Licenciatura en Marketing Digital
              </div>

              <h2
                style={{
                  margin: 0,
                  marginBottom: 10,
                  color: "#0f3b63",
                  fontWeight: 900,
                  textTransform: "uppercase",
                }}
              >
                Modalidad <span style={{ color: "#1b66c9" }}>Virtual</span>
              </h2>

              <p style={{ color: "#3d4e61", lineHeight: 1.8, marginTop: 0 }}>
                ¿Buscas estudiar una carrera universitaria sin descuidar tus
                actividades personales o laborales?
              </p>

              <p style={{ color: "#3d4e61", lineHeight: 1.8 }}>
                Nuestra modalidad 100% en línea es la opción perfecta para ti.
                Diseñada para ofrecerte flexibilidad, autonomía y calidad
                educativa, esta modalidad te permite avanzar a tu ritmo desde
                cualquier lugar y en cualquier momento.
              </p>

              <p style={{ color: "#3d4e61", lineHeight: 1.8 }}>
                Solo necesitas un dispositivo con acceso a internet para
                ingresar a nuestra plataforma virtual, donde encontrarás todos
                los contenidos, recursos y herramientas necesarias para tu
                formación. Aquí desarrollarás habilidades clave con el respaldo
                de docentes capacitados y una comunidad académica activa.
              </p>

              <p
                style={{
                  color: "#0f3b63",
                  fontWeight: 800,
                  lineHeight: 1.8,
                  marginTop: 10,
                }}
              >
                ¡Estudia sin barreras físicas y conviértete en un profesional
                competitivo desde donde estés!
              </p>
            </div>

            {/* Imagen + badge */}
            <div
              className="col-12 md:col-5 flex justify-content-center"
              style={{ paddingLeft: "1rem" }}
            >
              <div
                style={{ position: "relative", width: "100%", maxWidth: 420 }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/images/maestra.png`}
                  alt="Estudiante en modalidad virtual"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />

                {/* Badge “Virtual” */}
                <img
                  src={`${process.env.PUBLIC_URL}/images/Logo_ModalidadVirtual.png`}
                  alt="Modalidad Virtual"
                  style={{
                    position: "absolute",
                    bottom: 8,
                    right: 250,
                    width: 110,
                    height: "auto",
                    filter: "drop-shadow(0 6px 14px rgba(0,0,0,.12))",
                  }}
                  onError={(e) => (e.currentTarget.style.display = "none")}
                />
              </div>
            </div>
          </div>
        </section>
        {/* ===== BENEFICIOS MODALIDAD VIRTUAL ===== */}
        <section
          className="w-full"
          style={{
            position: "relative",
            overflow: "hidden",
            padding: "2.5rem 1rem",
            color: "#fff",
          }}
        >
          {/* Fondo (foto) */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: "url('/images/bg_virtual.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "saturate(.95)",
              zIndex: 0,
            }}
          />
          {/* Overlay naranja */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(242, 147, 63, 0.92)", // naranja con opacidad
              zIndex: 1,
            }}
          />

          {/* Contenido */}
          <div
            style={{
              position: "relative",
              zIndex: 2,
              maxWidth: 1200,
              margin: "0 auto",
            }}
          >
            <div className="grid" style={{ alignItems: "start" }}>
              {/* Columna izquierda */}
              <div className="col-12 md:col-6" style={{ paddingRight: "1rem" }}>
                <ul
                  style={{
                    margin: 0,
                    paddingLeft: 0,
                    listStyle: "none",
                    lineHeight: 1.7,
                  }}
                >
                  <li style={{ marginBottom: 14 }}>
                    <b style={{ color: "#0f3b63" }}>
                      Acceso permanente al Campus Virtual:
                    </b>
                    <br />
                    Los estudiantes pueden ingresar a los contenidos académicos
                    en cualquier momento del día. La plataforma está disponible
                    24/7, permitiendo adaptar el estudio al ritmo personal.
                  </li>

                  <li style={{ marginBottom: 14 }}>
                    <b style={{ color: "#0f3b63" }}>
                      Flexibilidad de horarios:
                    </b>
                    <br />
                    No se requiere conexión en horarios fijos; el modelo está
                    diseñado para que cada estudiante gestione su propio tiempo
                    de aprendizaje.
                  </li>

                  <li style={{ marginBottom: 14 }}>
                    <b style={{ color: "#0f3b63" }}>
                      Estudia desde cualquier lugar:
                    </b>
                    <br />
                    Independientemente de la distancia o país, se puede acceder
                    a la plataforma. Ideal para quienes trabajan, viven en zonas
                    remotas o viajan constantemente.
                  </li>

                  <li style={{ marginBottom: 14 }}>
                    <b style={{ color: "#0f3b63" }}>
                      Sin necesidad de presencia física:
                    </b>
                    <br />
                    Todo el proceso educativo, administrativo y de evaluación se
                    realiza en línea.
                  </li>
                </ul>
              </div>

              {/* Columna derecha */}
              <div className="col-12 md:col-6" style={{ paddingLeft: "1rem" }}>
                <ul
                  style={{
                    margin: 0,
                    paddingLeft: 0,
                    listStyle: "none",
                    lineHeight: 1.7,
                  }}
                >
                  <li style={{ marginBottom: 14 }}>
                    <b style={{ color: "#0f3b63" }}>
                      Interacción en entornos digitales:
                    </b>
                    <br />
                    Se fomenta el trabajo colaborativo y la participación
                    mediante foros, chats y videollamadas. Docentes y
                    estudiantes se comunican constantemente a través de medios
                    digitales.
                  </li>

                  <li style={{ marginBottom: 14 }}>
                    <b style={{ color: "#0f3b63" }}>
                      Soporte técnico y académico:
                    </b>
                    <br />
                    La universidad brinda acompañamiento durante toda la
                    carrera, con apoyo técnico para el uso de plataformas y
                    orientación académica personalizada.
                  </li>

                  <li style={{ marginBottom: 14 }}>
                    <b style={{ color: "#0f3b63" }}>
                      Calidad educativa digital:
                    </b>
                    <br />
                    La modalidad virtual mantiene los mismos estándares
                    académicos que la presencial. Se emplean recursos
                    multimedia, bibliografía digital y herramientas
                    interactivas.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* ===== CONOCE LAS BECAS ===== */}
        <section
          className="w-full"
          style={{
            position: "relative",
            background: "#f6f8fb",
            padding: "3rem 1rem",
            overflow: "hidden",
          }}
        >
          {/* Fondo tenue opcional */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: "url('/images/bg_campus_soft.jpg')",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: 0.15,
              pointerEvents: "none",
              zIndex: 0,
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 1,
              maxWidth: 1200,
              margin: "0 auto",
            }}
          >
            {/* Encabezado */}
            <div style={{ marginBottom: 18 }}>
              <div
                style={{
                  color: "#F2933F",
                  fontWeight: 800,
                  letterSpacing: ".5px",
                  marginBottom: 6,
                }}
              >
                CONOCE LAS
              </div>
              <h2 style={{ color: "#0f3b63", fontWeight: 900, margin: 0 }}>
                BECAS
              </h2>
              <p
                style={{
                  color: "#3d4e61",
                  lineHeight: 1.8,
                  maxWidth: 980,
                  marginTop: 8,
                }}
              >
                La Licenciatura en Marketing Digital de la UNICACH no solo
                ofrece flexibilidad académica, sino también oportunidades
                económicas para apoyar el desarrollo profesional de sus
                estudiantes. Con el objetivo de fomentar la permanencia, el buen
                desempeño y la equidad educativa, se ofrecen distintas becas a
                quienes cumplen con los requisitos establecidos.
              </p>
            </div>

            {/* Tarjetas */}
            <div className="grid" style={{ alignItems: "stretch" }}>
              {/* Beca por promedio académico */}
              <div className="col-12 md:col-4" style={{ padding: 8 }}>
                <div
                  style={{
                    height: "100%",
                    background: "rgba(255,255,255,0.95)",
                    border: "2px solid #F3B067",
                    borderRadius: 12,
                    padding: "1.1rem",
                    boxShadow: "0 6px 16px rgba(15,59,99,.06)",
                  }}
                >
                  <h3
                    style={{
                      color: "#0f3b63",
                      marginTop: 0,
                      marginBottom: 10,
                      fontWeight: 900,
                    }}
                  >
                    Beca por promedio académico.
                  </h3>
                  <ul
                    style={{
                      margin: 0,
                      paddingLeft: 18,
                      color: "#3d4e61",
                      lineHeight: 1.7,
                    }}
                  >
                    <li>Exoneración del pago de reinscripción.</li>
                    <li>
                      Dirigida a estudiantes que mantienen un promedio destacado
                      durante el ciclo escolar.
                    </li>
                    <li>
                      Permite exentar el costo de reinscripción como
                      reconocimiento al esfuerzo académico.
                    </li>
                    <li>
                      Se otorga directamente por la universidad conforme al
                      reglamento institucional.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Beca Santander */}
              <div className="col-12 md:col-4" style={{ padding: 8 }}>
                <div
                  style={{
                    height: "100%",
                    background: "rgba(255,255,255,0.95)",
                    border: "2px solid #F3B067",
                    borderRadius: 12,
                    padding: "1.1rem",
                    boxShadow: "0 6px 16px rgba(15,59,99,.06)",
                  }}
                >
                  <h3
                    style={{
                      color: "#0f3b63",
                      marginTop: 0,
                      marginBottom: 10,
                      fontWeight: 900,
                    }}
                  >
                    Beca Santander.
                  </h3>
                  <p
                    style={{ color: "#3d4e61", marginTop: 0, marginBottom: 8 }}
                  >
                    Formación, excelencia y movilidad.
                  </p>
                  <ul
                    style={{
                      margin: 0,
                      paddingLeft: 18,
                      color: "#3d4e61",
                      lineHeight: 1.7,
                    }}
                  >
                    <li>
                      Dirigida a estudiantes con sobresaliente desempeño
                      académico.
                    </li>
                    <li>
                      Apoyo económico único y/o acceso a cursos de desarrollo
                      profesional.
                    </li>
                    <li>
                      Convocatoria nacional e internacional; se reconoce el
                      mérito académico.
                    </li>
                    <li>
                      Requiere carta de motivos, comprobante de estudios y
                      promedio mínimo.
                    </li>
                    <li>
                      Convocatorias y registro en{" "}
                      <a
                        href="https://www.santanderopenacademy.com"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "#0f3b63", fontWeight: 700 }}
                      >
                        santanderopenacademy.com
                      </a>
                    </li>
                  </ul>

                  <div
                    style={{
                      marginTop: 14,
                      borderTop: "1px dashed #e9b680",
                      paddingTop: 10,
                    }}
                  >
                    <b style={{ color: "#0f3b63" }}>Otras Becas Santander</b>
                    <ul
                      style={{
                        margin: 6,
                        paddingLeft: 18,
                        color: "#3d4e61",
                        lineHeight: 1.7,
                      }}
                    >
                      <li>Formación en idiomas, liderazgo y tecnología.</li>
                      <li>
                        Movilidad internacional para estancias académicas.
                      </li>
                      <li>
                        Apoyo para emprendimiento o cursos especializados.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Beca Telmex */}
              <div className="col-12 md:col-4" style={{ padding: 8 }}>
                <div
                  style={{
                    height: "100%",
                    background: "rgba(255,255,255,0.95)",
                    border: "2px solid #F3B067",
                    borderRadius: 12,
                    padding: "1.1rem",
                    boxShadow: "0 6px 16px rgba(15,59,99,.06)",
                  }}
                >
                  <h3
                    style={{
                      color: "#0f3b63",
                      marginTop: 0,
                      marginBottom: 10,
                      fontWeight: 900,
                    }}
                  >
                    Beca Telmex.
                  </h3>
                  <p
                    style={{ color: "#3d4e61", marginTop: 0, marginBottom: 8 }}
                  >
                    Apoyo integral a estudiantes destacados.
                  </p>
                  <ul
                    style={{
                      margin: 0,
                      paddingLeft: 18,
                      color: "#3d4e61",
                      lineHeight: 1.7,
                    }}
                  >
                    <li>Apoyo económico mensual durante toda la carrera.</li>
                    <li>Incluye computadora e internet.</li>
                    <li>
                      Requisitos: promedio mínimo de 9.0, carta de motivos y
                      documentos oficiales.
                    </li>
                    <li>
                      Preferencia a estudiantes con compromiso social y
                      excelencia académica.
                    </li>
                    <li>
                      Convocatoria y requisitos en{" "}
                      <a
                        href="https://www.fundaciontelmex.org"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "#0f3b63", fontWeight: 700 }}
                      >
                        fundaciontelmex.org
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ===== CONOCE LOS INTERCAMBIOS ===== */}
        <section
          className="w-full"
          style={{
            background: "#f6f8fb",
            padding: "3rem 1rem",
          }}
        >
          <div style={{ maxWidth: 1100, margin: "0 auto" }}>
            {/* Encabezado */}
            <div style={{ marginBottom: 18 }}>
              <div
                style={{
                  color: "#F2933F",
                  fontWeight: 800,
                  letterSpacing: ".5px",
                  marginBottom: 6,
                }}
              >
                CONOCE LOS
              </div>
              <h2 style={{ color: "#0f3b63", fontWeight: 900, margin: 0 }}>
                INTERCAMBIOS
              </h2>

              <h3
                style={{
                  margin: "10px 0 8px",
                  color: "#0f3b63",
                  fontWeight: 800,
                }}
              >
                ¡Estudiar en línea no limita las oportunidades de crecimiento
                internacional!
              </h3>

              <p style={{ color: "#3d4e61", lineHeight: 1.8, marginTop: 0 }}>
                La Licenciatura en Marketing Digital de la UNICACH permite a sus
                estudiantes participar en programas de intercambio académico,
                brindando experiencias culturales y educativas que fortalecen el
                perfil profesional y personal del alumnado.
              </p>
            </div>

            {/* Bloques informativos */}
            <div className="grid" style={{ alignItems: "stretch" }}>
              {/* ¿En qué consisten los intercambios? */}
              <div className="col-12" style={{ padding: 8 }}>
                <div
                  style={{
                    height: "100%",
                    border: "2px solid #F3B067",
                    borderRadius: 12,
                    background: "#fff",
                    padding: "1.1rem",
                    boxShadow: "0 6px 16px rgba(15,59,99,.06)",
                  }}
                >
                  <b style={{ color: "#0f3b63" }}>
                    ¿En qué consisten los intercambios?
                  </b>
                  <ul
                    style={{
                      margin: "8px 0 0",
                      paddingLeft: 18,
                      color: "#3d4e61",
                      lineHeight: 1.75,
                    }}
                  >
                    <li>
                      Son estancias académicas temporales en universidades
                      nacionales o internacionales con las que UNICACH tiene
                      convenios.
                    </li>
                    <li>
                      Los estudiantes pueden cursar asignaturas que luego serán
                      revalidadas en su plan de estudios.
                    </li>
                    <li>
                      Se fomenta el aprendizaje intercultural, el desarrollo de
                      redes profesionales y la adquisición de nuevas
                      perspectivas del marketing digital.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Opciones disponibles */}
              <div className="col-12" style={{ padding: 8 }}>
                <div
                  style={{
                    height: "100%",
                    border: "2px solid #F3B067",
                    borderRadius: 12,
                    background: "#fff",
                    padding: "1.1rem",
                    boxShadow: "0 6px 16px rgba(15,59,99,.06)",
                  }}
                >
                  <b style={{ color: "#0f3b63" }}>Opciones disponibles:</b>
                  <ul
                    style={{
                      margin: "8px 0 0",
                      paddingLeft: 18,
                      color: "#3d4e61",
                      lineHeight: 1.75,
                    }}
                  >
                    <li>
                      <b>Convenios nacionales:</b> Los estudiantes pueden
                      participar en programas de intercambio con otras
                      instituciones de educación superior en México, ampliando
                      su experiencia académica dentro del país.
                    </li>
                    <li>
                      <b>Convenios internacionales:</b> La UNICACH mantiene
                      vínculos con universidades de distintos países, lo que
                      permite postularse para estancias académicas en el
                      extranjero, ya sea de forma presencial o virtual.
                    </li>
                    <li>
                      <b>Intercambios virtuales:</b> Gracias al modelo en línea,
                      es posible cursar asignaturas en universidades
                      internacionales desde casa, manteniendo contacto con
                      docentes y compañeros de otros contextos culturales.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Requisitos generales */}
              <div className="col-12" style={{ padding: 8 }}>
                <div
                  style={{
                    height: "100%",
                    border: "2px solid #F3B067",
                    borderRadius: 12,
                    background: "#fff",
                    padding: "1.1rem",
                    boxShadow: "0 6px 16px rgba(15,59,99,.06)",
                  }}
                >
                  <b style={{ color: "#0f3b63" }}>Requisitos generales:</b>
                  <ul
                    style={{
                      margin: "8px 0 0",
                      paddingLeft: 18,
                      color: "#3d4e61",
                      lineHeight: 1.75,
                    }}
                  >
                    <li>
                      Ser estudiante regular de la Licenciatura en Marketing
                      Digital.
                    </li>
                    <li>
                      Tener un promedio mínimo (generalmente 8.0 o superior).
                    </li>
                    <li>
                      Presentar carta de motivos y cumplir con los trámites de
                      movilidad establecidos por la Dirección de Vinculación y
                      Relaciones Interinstitucionales.
                    </li>
                    <li>
                      En algunos casos, demostrar nivel de idioma si el
                      intercambio es en un país de habla no hispana.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Beneficios */}
              <div className="col-12" style={{ padding: 8 }}>
                <div
                  style={{
                    height: "100%",
                    border: "2px solid #F3B067",
                    borderRadius: 12,
                    background: "#fff",
                    padding: "1.1rem",
                    boxShadow: "0 6px 16px rgba(15,59,99,.06)",
                  }}
                >
                  <b style={{ color: "#0f3b63" }}>Beneficios:</b>
                  <ul
                    style={{
                      margin: "8px 0 0",
                      paddingLeft: 18,
                      color: "#3d4e61",
                      lineHeight: 1.75,
                    }}
                  >
                    <li>Ampliación del panorama académico y profesional.</li>
                    <li>
                      Mejora en la empleabilidad al incluir una experiencia
                      internacional en el currículum.
                    </li>
                    <li>
                      Fortalecimiento de competencias interculturales y de
                      adaptación.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ===== PLAN DE ESTUDIOS (layout alineado a la izquierda) ===== */}
        <section
          className="w-full"
          style={{
            position: "relative",
            background: "#f1f3f7", // gris claro del mock
            padding: "3rem 0 4rem",
            overflow: "hidden",
          }}
        >
          {/* Fondo tenue opcional (laboratorio/oficina) */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: "url('/images/bg_lab_soft.jpg')", // ← cambia por tu imagen
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: 0.12,
              zIndex: 0,
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 1,
              maxWidth: 1200,
              margin: "0 auto",
            }}
          >
            <div className="grid">
              {/* Columna izquierda: Títulos + texto (≈ 7/12 del ancho) */}
              <div className="col-12" style={{ padding: "0 1rem" }}>
                <div
                  style={{
                    color: "#F2933F",
                    fontWeight: 800,
                    letterSpacing: ".5px",
                    marginBottom: 4,
                  }}
                >
                  PLAN DE
                </div>

                <h2
                  style={{
                    margin: 0,
                    color: "#0f3b63",
                    fontWeight: 900,
                    fontSize: "clamp(28px, 4vw, 44px)", // tamaño similar al mock
                    lineHeight: 1.1,
                  }}
                >
                  ESTUDIOS
                </h2>

                <h3
                  style={{
                    margin: "14px 0 10px",
                    color: "#0f3b63",
                    fontWeight: 800,
                    fontSize: "clamp(16px, 2.2vw, 22px)",
                  }}
                >
                  ¡Conecta con el futuro del marketing!
                </h3>

                <p
                  style={{
                    color: "#616f83",
                    lineHeight: 1.85,
                    marginTop: 6,
                    marginBottom: 28,
                    textAlign: "justify",
                    maxWidth: "90%", // 🔹 más ancho
                  }}
                >
                  El plan de estudios de la Licenciatura en Marketing Digital de
                  la UNICACH está cuidadosamente estructurado para responder a
                  las necesidades del entorno digital actual y del mercado
                  global. Gracias a su enfoque práctico, actualizado y 100% en
                  línea, este plan impulsa la formación de profesionales capaces
                  de liderar la transformación digital en empresas e
                  instituciones.
                </p>
              </div>

              {/* Columna derecha vacía para respetar el balance visual (≈ 5/12) */}
              <div className="col-12 md:col-5" />
            </div>

            {/* Botón centrado debajo del bloque de texto */}
            <div
              className="flex justify-content-center"
              style={{ padding: "0 1rem", marginTop: 4 }}
            >
              <button
                style={{
                  background: "#F2933F",
                  color: "#0f3b63",
                  border: "none",
                  borderRadius: 14,
                  padding: "0.95rem 1.6rem",
                  fontWeight: 800,
                  fontSize: "clamp(15px, 1.9vw, 20px)",
                  cursor: "pointer",
                  boxShadow: "0 8px 20px rgba(15,59,99,.15)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                  minWidth: 360, // ancho vistoso como en el mock
                  justifyContent: "center",
                }}
                onClick={() =>
                  window.open(
                    `${process.env.PUBLIC_URL}/docs/PLAN_ESTUDIOS.pdf`,
                    "_blank",
                  )
                }
                aria-label="Descargar Plan de Estudios"
                title="Descargar Plan de Estudios"
              >
                Descargar Plan de Estudios
                <i className="pi pi-download" style={{ fontSize: 18 }} />
              </button>
            </div>

            {/* Frase final centrada */}
            <div style={{ textAlign: "center", marginTop: 18 }}>
              <h4
                style={{
                  color: "#0f3b63",
                  fontWeight: 900,
                  fontSize: "clamp(14px, 2vw, 18px)",
                  margin: "0 1rem 14px",
                }}
              >
                ¡Diseñado para formar estrategas digitales con visión,
                innovación y dominio tecnológico!
              </h4>

              {/* Chip de correo */}
              <div
                style={{
                  display: "inline-block",
                  background: "#F2933F",
                  color: "#ffffff",
                  borderRadius: 22,
                  padding: "0.45rem 1rem",
                  fontWeight: 700,
                  fontSize: "clamp(12px, 1.6vw, 15px)",
                  boxShadow: "0 4px 12px rgba(15,59,99,.15)",
                }}
              >
                Escríbenos:{" "}
                <a
                  href="mailto:mkt.digital@unicach.mx"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  mkt.digital@unicach.mx
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* ===== PERFIL DE INGRESO / EGRESO ===== */}
        <section
          className="w-full"
          style={{
            background: "#f6f8fb",
            padding: "3rem 1rem 4rem",
            overflow: "hidden",
          }}
        >
          <div style={{ maxWidth: 1100, margin: "0 auto", color: "#0f3b63" }}>
            {/* Encabezado principal */}
            <div style={{ marginBottom: 18 }}>
              <div
                style={{
                  color: "#F2933F",
                  fontWeight: 800,
                  letterSpacing: ".5px",
                  marginBottom: 4,
                }}
              >
                PERFIL DE
              </div>
              <h2
                style={{
                  color: "#0f3b63",
                  fontWeight: 900,
                  margin: 0,
                  fontSize: "clamp(26px, 4vw, 42px)",
                }}
              >
                INGRESO / EGRESO
              </h2>

              <h3
                style={{
                  marginTop: 10,
                  fontWeight: 800,
                  color: "#0f3b63",
                  fontSize: "clamp(16px, 2vw, 22px)",
                }}
              >
                ¡Del talento al impacto: tu camino profesional en Marketing
                Digital!
              </h3>

              <p
                style={{
                  color: "#3d4e61",
                  lineHeight: 1.8,
                  marginTop: 10,
                  marginBottom: 16,
                  textAlign: "justify",
                }}
              >
                La Licenciatura en Marketing Digital de la UNICACH está diseñada
                para personas con visión, iniciativa y pasión por la innovación.
                Desde el inicio, el programa impulsa el desarrollo de
                habilidades analíticas, creativas y tecnológicas que permiten al
                estudiante adaptarse al entorno digital en constante evolución.
              </p>

              <p
                style={{
                  color: "#3d4e61",
                  lineHeight: 1.8,
                  textAlign: "justify",
                  marginBottom: 16,
                }}
              >
                Quienes ingresan a esta carrera comparten una mentalidad
                proactiva, una actitud colaborativa y un interés genuino por las
                herramientas digitales. Al egresar, se convierten en
                profesionales capaces de crear estrategias de marketing
                competitivas, responsables y alineadas con las nuevas dinámicas
                del mercado global.
              </p>

              <p
                style={{
                  color: "#3d4e61",
                  lineHeight: 1.8,
                  textAlign: "justify",
                  marginBottom: 24,
                }}
              >
                Ya sea que sueñes con emprender, dirigir campañas digitales o
                liderar proyectos innovadores dentro de una empresa, aquí
                encontrarás la formación integral que te permitirá hacerlo
                realidad.
              </p>
            </div>

            {/* PERFIL DE INGRESO */}
            <div
              className="border-1 border-round-lg w-full relative px-4 md:px-5 py-3 grid "
              style={{
                borderColor: "#F2933F",
                background: "#ffffff",
                minHeight: "auto",
              }}
            >
              <div className="md:w-full -mt-3 lg:col-11 -mb-5">
                {/* Texto */}
                <div className="col-12">
                  <b
                    style={{
                      color: "#0f3b63",
                    }}
                  >
                    PERFIL DE INGRESO
                  </b>
                </div>

                <div className="col-12 -mt-4 lg:col-10 ">
                  <p
                    style={{
                      color: "#3d4e61",
                      lineHeight: "1.6",
                    }}
                  >
                    El aspirante ideal a la Licenciatura en Marketing Digital en
                    UNICACH es una persona creativa, analítica y con interés por
                    la tecnología y la comunicación. Tiene facilidad para
                    trabajar en equipo, se adapta al cambio y busca aprender de
                    forma autónoma.
                  </p>
                </div>
              </div>

              {/* Imagen ABSOLUTA (no afecta el tamaño del div) */}
              <img
                className="hidden lg:block"
                src={`${process.env.PUBLIC_URL}/images/perfildeingreso.png`}
                alt="Perfil de ingreso"
                style={{
                  position: "absolute",
                  right: "40px",
                  height: "180px",
                  bottom: "0",
                  width: "auto",
                  objectFit: "contain",
                  transform: "translateY(6.2%)",
                }}
              />
            </div>

            {/* HABILIDADES Y ACTITUDES */}
            <div
              className="border-1 border-round-lg w-full relative px-4 md:px-5 py-3 grid mt-5"
              style={{
                borderColor: "#F2933F",
                background: "#ffffff",
                minHeight: "auto",
              }}
            >
              <div className="md:w-full -mt-3 lg:col-11 -mb-3">
                {/* Texto */}
                <div className="col-12">
                  <b
                    style={{
                      color: "#0f3b63",
                    }}
                  >
                    HABILIDADES Y ACTITUDES ESPERADAS
                  </b>
                </div>

                <div className="col-12 -mt-3 lg:col-10 ">
                  <ul
                    style={{
                      color: "#3d4e61",
                      margin: "6px 0 0 18px",
                      lineHeight: 1.7,
                    }}
                  >
                    <li>Buena comunicación oral y escrita.</li>
                    <li>Pensamiento crítico y creativo.</li>
                    <li>
                      Interés por herramientas digitales y redes sociales.
                    </li>
                    <li>Capacidad para aprender de forma independiente.</li>
                    <li>Valores como respeto, honestidad y compromiso.</li>
                  </ul>
                </div>
              </div>

              {/* Imagen ABSOLUTA (no afecta el tamaño del div) */}
              <img
                className="hidden lg:block"
                src={`${process.env.PUBLIC_URL}/images/habilidades2.png`}
                alt="Habilidades y actitudes"
                style={{
                  position: "absolute",
                  right: "40px",
                  height: "180px",
                  bottom: "0",
                  width: "auto",
                  objectFit: "contain",
                  transform: "translateY(0.7%)",
                }}
              />
            </div>

            {/* Texto intermedio */}
            <div
              style={{
                textAlign: "center",
                margin: "2rem 0",
                color: "#0f3b63",
                fontWeight: 700,
              }}
            >
              ¡Solo necesitas un equipo de cómputo con internet para acceder a
              la plataforma en cualquier momento y lugar!
            </div>

            {/* PERFIL DE EGRESO */}
            <div
              className="border-1 border-round-lg w-full relative px-4 md:px-5 py-3 grid mt-5"
              style={{
                borderColor: "#F2933F",
                background: "#ffffff",
                minHeight: "auto",
              }}
            >
              <div className="md:w-full -mt-3 lg:col-11 -mb-5">
                {/* Texto */}
                <div className="col-12">
                  <b
                    style={{
                      color: "#0f3b63",
                    }}
                  >
                    PERFIL DE EGRESO
                  </b>
                </div>

                <div className="col-12 -mt-3 lg:col-10 ">
                  <p
                    style={{
                      color: "#3d4e61",
                      lineHeight: "1.6",
                    }}
                  >
                    El egresado de la Licenciatura en Marketing Digital en
                    UNICACH será un profesional capaz de crear y gestionar
                    estrategias de marketing digital, aplicando conocimientos en
                    tecnología, negocios y comunicación, con visión global y
                    responsabilidad social.
                  </p>
                </div>
              </div>

              {/* Imagen ABSOLUTA (no afecta el tamaño del div) */}
              <img
                className="hidden lg:block"
                src={`${process.env.PUBLIC_URL}/images/perfildeegreso.png`}
                alt="Perfil de egreso"
                style={{
                  position: "absolute",
                  right: "40px",
                  height: "180px",
                  bottom: "0",
                  width: "auto",
                  objectFit: "contain",
                  transform: "translateY(13%)",
                }}
              />
            </div>

            {/* COMPETENCIAS ADQUIRIDAS */}
            <div
              className="border-1 border-round-lg w-full relative px-4 md:px-5 py-3 grid mt-5"
              style={{
                borderColor: "#F2933F",
                background: "#ffffff",
                minHeight: "auto",
              }}
            >
              <div className="md:w-full -mt-3 lg:col-11 -mb-3">
                {/* Texto */}
                <div className="col-12">
                  <b
                    style={{
                      color: "#0f3b63",
                    }}
                  >
                    COMPETENCIAS ADQUIRIDAS
                  </b>
                </div>

                <div className="col-12 -mt-4 lg:col-10 ">
                  <ul
                    style={{
                      color: "#3d4e61",
                      margin: "6px 0 0 18px",
                      lineHeight: 1.7,
                    }}
                  >
                    <li>
                      Diseña campañas con medios digitales y tradicionales.
                    </li>
                    <li>Aplica procesos de negocio en entornos digitales.</li>
                    <li>
                      Desarrolla estrategias alineadas a logros nacionales e
                      internacionales.
                    </li>
                    <li>
                      Evalúa resultados con métricas digitales y estudios de
                      mercado.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Imagen ABSOLUTA (no afecta el tamaño del div) */}
              <img
                className="hidden lg:block"
                src={`${process.env.PUBLIC_URL}/images/competencias_adquiridas.png`}
                alt="Competencias adquiridas"
                style={{
                  position: "absolute",
                  right: "40px",
                  height: "180px",
                  bottom: "0",
                  width: "auto",
                  objectFit: "contain",
                  transform: "translateY(7%)",
                }}
              />
            </div>

            {/* Frase final */}
            <div
              style={{
                textAlign: "center",
                marginTop: 30,
                color: "#0f3b63",
                fontWeight: 900,
                fontSize: "1.05rem",
              }}
            >
              ¡Podrá desempeñarse en empresas, agencias, medios digitales o
              emprender su propio proyecto!
            </div>
          </div>
        </section>

        {/* ===== NUESTRAS REDES SOCIALES ===== */}
        <section
          className="w-full"
          style={{ background: "#fff", padding: "2.5rem 1rem" }}
        >
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div
              style={{
                color: "#F2933F",
                fontWeight: 800,
                letterSpacing: ".5px",
                marginBottom: 6,
              }}
            >
              NUESTRAS
            </div>
            <h2
              style={{
                color: "#0f3b63",
                fontWeight: 900,
                marginTop: 0,
                marginBottom: 24,
              }}
            >
              REDES SOCIALES
            </h2>

            <div className="grid">
              {/* Facebook */}
              <div className="col-12 md:col-4 p-2">
                <a
                  href="https://facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-column align-items-center justify-content-center w-full"
                  style={{
                    textDecoration: "none",
                    border: "3px solid #F3B067",
                    borderRadius: 16,
                    padding: "2rem 1rem",
                    transition: "all .2s ease",
                    color: "#0f3b63",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.boxShadow =
                      "0 10px 22px rgba(15,59,99,.12)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.boxShadow = "none")
                  }
                >
                  <i
                    className="pi pi-facebook"
                    style={{ fontSize: 64, color: "#0f3b63" }}
                  />
                  <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                    Facebook
                  </div>
                </a>
              </div>

              {/* Instagram */}
              <div className="col-12 md:col-4 p-2">
                <a
                  href="https://instagram.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-column align-items-center justify-content-center w-full"
                  style={{
                    textDecoration: "none",
                    border: "3px solid #F3B067",
                    borderRadius: 16,
                    padding: "2rem 1rem",
                    transition: "all .2s ease",
                    color: "#0f3b63",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.boxShadow =
                      "0 10px 22px rgba(15,59,99,.12)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.boxShadow = "none")
                  }
                >
                  <i
                    className="pi pi-instagram"
                    style={{ fontSize: 64, color: "#0f3b63" }}
                  />
                  <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                    Instagram
                  </div>
                </a>
              </div>

              {/* YouTube */}
              <div className="col-12 md:col-4 p-2">
                <a
                  href="https://youtube.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-column align-items-center justify-content-center w-full"
                  style={{
                    textDecoration: "none",
                    border: "3px solid #F3B067",
                    borderRadius: 16,
                    padding: "2rem 1rem",
                    transition: "all .2s ease",
                    color: "#0f3b63",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.boxShadow =
                      "0 10px 22px rgba(15,59,99,.12)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.boxShadow = "none")
                  }
                >
                  <i
                    className="pi pi-youtube"
                    style={{ fontSize: 64, color: "#0f3b63" }}
                  />
                  <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                    Youtube
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
